<template>
    <div class="game-tag-exploring">
        <span class="hidden-xs-only">
            <el-button type="primary"
                       plain
                       icon="el-icon-plus"
                       size="mini"
                       class="retro retro-status-button"
                       v-if="!game.status"
                       :loading="!!game.updatingStatus"
                       @click="addStatus(game, 'myGames')">
                my games!
            </el-button>

            <div v-else class="added-game">Added to your games</div>
        </span>

        <span class="hidden-sm-and-up">
            <i v-if="!game.status" :loading="!!game.updatingStatus" @click="addStatus(game, 'myGames')" class="el-icon-circle-plus add-game clickable"></i>
            <i v-else class="added-game el-icon-success"></i>
        </span>
    </div>
</template>

<script>
export default {
  name: 'gameTagExploring',
  components: {},
  props: ['game', 'addGameEnabled', 'addStatus'],
  mounted () {
  },
  data () {
    return {
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.game-tag-exploring {
    margin-top: -0.3em;

    .retro-status-button {
        font-size: $font-size-small !important;
    }

    .added-game {
        font-size: $font-size-small;
        text-shadow: #2d00ff 1px 0 10px;
        margin-top: 1em;
    }

    @media screen and (max-width: 35em) {
        margin-top: 0em;

        .game-status {
            margin-right: -10px;
        }

        .add-game {
            margin-left: 10px;
        }

        .added-game {
            font-size: $font-size-regular;
            text-shadow: #2d00ff 1px 0 10px;
            margin-top: 0em;
        }
    }
}
</style>
